const removeFalsyValuesInObj = obj => {
  if (!obj) {
    return {};
  }
  Object.entries(obj).forEach(([key, value]) => {
    if (!value) {
      delete obj[key];
    }
  });
  return obj;
};

export default removeFalsyValuesInObj;
